export default class County {
    id: number;
    name: string;
    stateId: number;
}



// WEBPACK FOOTER //
// ./src/models/County.ts